import { Checkbox, Divider } from "@mui/material";
import {
  SwatchesIcon,
  ListBulletsIcon,
  ListDashesIcon,
  BedIcon,
  HamburgerIcon,
  SwapIcon,
} from "@phosphor-icons/react";
import type { ChangeEvent } from "react";
import { useIntl } from "react-intl";

import { BOARD_BASIS_OPTIONS } from "@/features/hotels/utils/constants";

const BOARD_BASIS_ICONS: Record<string, React.JSX.Element> = {
  HB: <ListDashesIcon size={20} className="fill-secondary" />,
  FB: <ListBulletsIcon size={20} className="fill-secondary" />,
  AI: <SwatchesIcon size={20} className="fill-secondary" />,
  RO: <BedIcon size={20} className="fill-secondary" />,
  SC: <HamburgerIcon size={20} className="fill-secondary" />,
  BB: <SwapIcon size={20} className="fill-secondary" />,
  RD: <BedIcon size={20} className="fill-secondary" />,
};

type Props = {
  selected?: string[];
  userManuallySelectedAll: boolean;
  onChange: (
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
    option: string,
  ) => void;
};

export const BoardBasisFilter = ({
  selected = [],
  userManuallySelectedAll,
  onChange,
}: Props) => {
  const intl = useIntl();

  const areAllClassesSelected = selected.length === BOARD_BASIS_OPTIONS.length;

  return (
    <ul>
      {BOARD_BASIS_OPTIONS.map((option) => (
        <li key={option}>
          <label className="flex w-full items-center justify-between py-2">
            <div className="flex items-center gap-4">
              {BOARD_BASIS_ICONS[option]}
              <span className="font-medium text-text-primary">
                {intl.formatMessage({ id: `hotels.boardBasis.${option}` })}
              </span>
            </div>
            <Checkbox
              checked={
                selected?.includes(option) &&
                (userManuallySelectedAll || !areAllClassesSelected)
              }
              onChange={(e, checked) => onChange(e, checked, option)}
              sx={{ padding: "6px" }}
            />
          </label>
          <Divider />
        </li>
      ))}
    </ul>
  );
};
